import { AdminAccountService, ObserverService, ListingModalService } from '@DavisDigital/davisdigitalfrontend.module';

class DistrictAdminController {
	
	public districtAccountSettings;
	public districtAccountSettingsUpdated: boolean = false;
	public districtUsageReport;
	
	public accountIDList:string = "";
	public allAccountsSelected:boolean = false;
	public selectedAccounts = [];
	public pageRole:string = "";
	public davisDataImportCount = 0;
	public lastImportCountTime;
	public davisDataLicenseCount = 0;
	public lastLicenseCountTime;
	public accountFilters: any;
	
	public accountsSelected: boolean = false;
	
	private submittingUpdate: boolean = false;
	private gettingLicenseCount: boolean = false;
	private gettingImportCount: boolean = false;
	private gettingDistrictAccountSettings: boolean = false;
	public get loading() { return this.submittingUpdate || this.gettingImportCount || this.gettingDistrictAccountSettings || this.gettingLicenseCount; }
	public formState = {formHasErrors: false};
	public formObj = {
		entity: 'account',
		accountID: ''
	};
	
	//todo: make more generic, create interface abstract out into its own directive
	public formFields = [
		{
			display: 'First Name',
			property: 'firstName',
			type: 'text',
			validators: { required:true }
		},		
		{
			display: 'Last Name',
			property: 'lastName',
			type: 'text',
			validators: { required:true }
		},
		{
			display: 'Email Address',
			property: 'emailAddress',
			type: 'email',
			validators: { 
				required:() => !this.formObj['username'],
				requiredMessage: 'Email Address is required if Username is not provided',
				minLength: 5,
				match: { property: 'emailAddressConfirm', display:'Email Address Confirm' }
			}
		},
		{
			display: 'Confirm Email Address',
			property: 'emailAddressConfirm',
			type: 'email',
			validators: {
				required:() => !this.formObj['username'] || !!this.formObj['emailAddress'],
				minLength: 5,
				match: { property: 'emailAddress', display:'Email Address' }
			}
		},
		{
			display: 'User Name',
			property: 'username',
			type: 'text',
			validators: { 
				required:() => !this.formObj['emailAddress'],
				requiredMessage: 'Username is required if Email Address is not provided',
				maxLength: 25
			}
		},
		{
			display: 'Account Role',
			property: 'accountType',
			type: 'select',
			options: [{ display:'Student', property: 'Student' }, { display:'Admin', property: 'Admin' }, { display:'Faculty', property: 'Faculty' }],
			validators: { required:true },
			defaultValue: 'Student'
		},
		{
			display: 'Password',
			property: 'password',
			type: 'Password',
			requiredFlag: true,
			validators: { required:true, match: { property: 'passwordConfirm', display:'Confirm Password' } }
		},
		{
			display: 'Confirm Password',
			property: 'passwordConfirm',
			type: 'Password',
			validators: { required:true, match: { property: 'password', display:'password' } }
		}
	];
	
	// @ngInject
	constructor(
		private adminAccountService:AdminAccountService,
		private observerService:ObserverService,
		private davisAlertService,
		private publicService,
		private $location       : ng.ILocationService
		
	){
	}
	
	public $onInit = () =>{
		for(let field of this.formFields){
			//load the fields into the formObj to be sent to the server as our payload, also add to form state for errors/state logic
			this.formObj[field.property] = field.defaultValue;
			this.formState[field.property] = { errors: [] };
		}
		
		this.pageRole = this.$location.search().role;
		
		this.getDavisDataImportCount();
		this.getDavisDataLicenseCount();
	}
	
	public createAccount(){
		this.validateForm();
		if(this.formState.formHasErrors){
			return;
		}
		this.submittingUpdate = true;
		this.adminAccountService.createAccount(this.formObj).then(res => {
			let errorsObj = res.errors || {};
			let failures = res.failureActions || {};
			if( failures.length ){
				for(let property in errorsObj){
					if(this.formState.hasOwnProperty(property)){
						this.formState[property].errors = [ errorsObj[property][0] ];
					}
					
				}
			}else{
				this.davisAlertService.success('Account Created Successfully');
				this.publicService.showModal = false;
			}
			
			this.submittingUpdate = false;
		});
	}
	
	private validateForm(){
		let formHasErrors = false;
		for ( let field of this.formFields ) {
			let validators = field['validators'];
			if ( validators ) {
				//clear all errors to avoid dupes
				this.formState[field.property].errors = [];
				let required: boolean = typeof validators.required === 'function' ? validators.required() : validators.required;
				if( required === true ) {
					if( !(this.formObj[field.property]) ) {
						formHasErrors = true;
						this.formState[field.property].errors.push(validators.requiredMessage ? validators.requiredMessage : `${field.display} is required`);	
						continue; // continue here because if the property is not present, no more validation can be done
					}
				}
				
				if ( validators.minLength && this.formObj[field.property] ) {
					if( this.formObj[field.property].length < validators.minLength ) {
						formHasErrors = true;
						this.formState[field.property].errors.push(field.display + ' must be greater than ' + validators.minLength + ' characters');	
					}
				}	
				
				if ( validators.maxLength ) {
					if( this.formObj[field.property] && this.formObj[field.property].length > validators.maxLength ) {
						formHasErrors = true;
						this.formState[field.property].errors.push(field.display + ' must be less than ' + validators.maxLength + ' characters');	
					}
				}	
				
				if ( validators.match && validators.match.property ) {
					if( this.formObj[field.property] != this.formObj[validators.match.property] ) {
						formHasErrors = true;
						this.formState[field.property].errors.push(field.display + ' does not match ' + validators.match.display);	
					}
				}
			
			}
		}
		
		this.formState['formHasErrors'] = formHasErrors;
	}
	
	public getDavisDataImportCount = () =>{
		this.gettingImportCount = true; 
		this.adminAccountService.getDavisDataImportCount().then((response)=>{
			this.davisDataImportCount = response['davisDataImportCount'];
			this.lastImportCountTime = Date.now();
			this.gettingImportCount = false;
		});
	}
	
	public getDavisDataLicenseCount = () =>{
		this.gettingLicenseCount = true; 
		this.adminAccountService.getDavisDataLicenseCount().then((response)=>{
			this.davisDataLicenseCount = response['davisDataLicenseCount'];
			this.lastLicenseCountTime = Date.now();
			this.gettingLicenseCount = false;
		});
	}
	
	public getDistrictAccountSettings = () =>{
		this.gettingDistrictAccountSettings = true; 
		this.adminAccountService.getDistrictAccountSettings().then((response)=>{
			this.districtAccountSettings = response;
			this.gettingDistrictAccountSettings = false; 
		})
	}
	
	public getDistrictUsageReport = () =>{
		this.adminAccountService.getDistrictUsageReport().then((response)=>{
			this.districtUsageReport = response; 
		})
	}
	
	/**
	 * Call back function to get selected accounts from account list
	 * */
	public handlePermissionCallback = ( accountIDList: string, allAccountsSelected: boolean = false, accountFilters: any = {} ) => {
		//save in parent properties, so we can use in directive
		this.accountsSelected = true;
		this.selectedAccounts = [];
		this.accountIDList = accountIDList;
		this.allAccountsSelected = allAccountsSelected;
		this.accountFilters = accountFilters;
	}
	
	public handleBulkPermissionCallback = () => {
		this.accountsSelected = false;
		this.selectedAccounts = [];
		this.accountIDList = "";
		this.allAccountsSelected = false;
		this.accountFilters = {};
		this.getDavisDataImportCount();
		this.getDavisDataLicenseCount();
	}
	
	public updateDistrictAccountSettings = () =>{
		this.submittingUpdate = true; 
		
		this.adminAccountService.updateDistrictAccountSettings(this.districtAccountSettings)
			.then((response)=>{
				this.districtAccountSettings = response;
				this.districtAccountSettingsUpdated = response['success'];
			})
			.finally( () =>{
				this.submittingUpdate = false; 
			});
	}
	
	

}

export { DistrictAdminController };